import actions from './actions';
import { createReducer } from '../../../../../helpers/reducer';

const initState = {
  specificAccreditations: [],
  parentAccreditations: [],
  specificAccreditationsLoading: false,
  parentAccreditationsLoading: false,
};

function onLoadDataRequest(state, { payload }) {
  return {
    ...state,
    specificAccreditationsLoading: !payload.parent_id,
    parentAccreditationsLoading: !!payload.parent_id,
  };
}

function onLoadDataSuccess(state, { payload }) {
  const { data, parent_id } = payload;

  return {
    ...state,
    specificAccreditations: !parent_id ? data : state.specificAccreditations,
    parentAccreditations: parent_id ? data : state.parentAccreditations,
    specificAccreditationsLoading: false,
    parentAccreditationsLoading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD_DATA_REQUEST]: onLoadDataRequest,
  [actions.LOAD_DATA_SUCCESS]: onLoadDataSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
